<template>
	<div id="app">
		<navbar :to="'/film'" />
		
		
		<div class="containner mt-20 flex item-start wrap">
			<div v-for="film of $store.getters.filmqueryvo.films"
			:key="film.filmId" 
			@click="film_click(film.filmId)"
			class="film mx-10 my-10 px-10 py-10 rounded box-shadow hand hover-box-shadow-blue">
				<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
				<div class="flex item-end justify-between mt-5">
					<div class="dark text-sm">{{film.filmName.length > 9 ? film.filmName.substr(0,9)+'...' : film.filmName}}</div>
					<div v-if="film.filmPraise" class="red text-xl weight">{{film.filmPraise}}</div>
					<div v-if="!film.filmPraise" class="red text-xl weight">暂无</div>
				</div>
			</div>
		</div>

		<div v-if="$store.getters.filmqueryvo.bo">
			<page :totalpage="$store.getters.filmqueryvo.bo.totalPage" @parentClick="pageEvent"/>
		</div>
	
		<foot />

	</div>
</template>

<script>
	
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	import page from '@/components/page.vue'
	
	export default {
		data () {
			return {
				//参数对象
				routeQuery: {
					currentIndex: 1,
					pageSize: 10,
					totalRecord: 0,
					totalPage: 0,
					orderCol: null,
					orderDir: null,
					searchContent: null
				}
			}
		},
		methods: {
			loads () {
				console.log(this.$route.query)
				this.routeQuery = this.$route.query
				this.$store.dispatch('actFilmloads', {
					payload: this.routeQuery
					
				})
			},
			handFilter (routequery) {
				this.$router.push({
					path: '/search',
					query: routequery
				})
			},
			film_click (filmId) {
				this.$router.push({
					path: `/film/${filmId}`
				})
			},
			pageEvent (event) {
				this.routeQuery.currentIndex = event
				this.handFilter(this.routeQuery)
			}
		},
		watch: {
		   "$route": "loads"
		},
		mounted () {
			this.loads()
			
		},
		components:{
			navbar,
			foot,
			page
		}
		
	}
</script>

<style>
	.option.active{background-color: #e1251b; color: #fff;}
</style>
